import { Transfer } from '../types/transfer/Transfer';
import type { TAB_TYPE } from '../types/actionBars';

export const countRedDot = (data: Transfer[], tabType: TAB_TYPE) => {
  if (tabType === 'APPROVAL') {
    return data.length;
  }

  if (tabType === 'SHIPMENT') {
    const shipmentStatusKeys = ['PARTIALLY_SHIPPED', 'WAITING_FOR_SHIPMENT'];
    return data.filter((transfer) =>
      shipmentStatusKeys.includes(transfer.status_key)
    ).length;
  }

  if (tabType === 'REJECTED') {
    const reviseNeededData = data.filter(
      (transfer) => transfer.status_key === 'REVISE_NEEDED'
    );
    return reviseNeededData.length;
  }

  if (tabType === 'FULFILLMENT') {
    const inProgressFulfill = data.filter(
      (transfer) => parseFloat(transfer.fulfilled_percentage) < 100
    );
    return inProgressFulfill.length;
  }

  return null;
};
